import { AddVoiceToCompanyParams, RemoveVoiceFromCompanyParams } from "../types/requestInputs";
import { GetVoicesResponse } from "../types/requestsOutputs";
import { MessageResponse } from "../types/types";
import { getLanguageDisplayName } from "../utils/language";
import { fetchAPI } from "./utils";

// Get available voices for a language
export const getVoices = async ({
    token,
    language,
}: {
    token: string;
    language?: string;
}): Promise<GetVoicesResponse> => {
    const data = await fetchAPI<GetVoicesResponse>("/get-voices", "GET", undefined, token, language);

    const voices = data.map((voice) => {
        const typedVoice: any = voice;
        const isCloned = Boolean(typedVoice?.isCloned);
        const voiceCloneDbId = typedVoice?.voiceCloneDbId ?? null;
        const isPromptVoice = Boolean(typedVoice?.isPromptVoice);
        const promptVoiceDbId = typedVoice?.promptVoiceDbId ?? null;
        return {
            id: voice.id,
            value: voice.id,
            name: voice.name,
            gender: voice.gender,
            language: getLanguageDisplayName(voice.language.toUpperCase()),
            description: voice?.voiceAILocalized[0]?.description,
            demoUrl: voice.demoUrl,
            isActivated: voice.company,
            isAllLanguages: voice.isAllLanguages,
            createdAt: voice.createdAt,
            updatedAt: voice.updatedAt,
            isActive: voice.isActive,
            origin: voice.origin,
            isCloned,
            company: voice.company,
            voiceAILocalized: voice.voiceAILocalized,
            label: `${voice.name}, ${getLanguageDisplayName(voice.language.toUpperCase())} voice`,
            voiceCloneDbId,
            isPromptVoice,
            promptVoiceDbId,
        };
    });

    return voices;
};

// Add a voice to the company's available voices
export const addVoiceToCompany = async ({ token, voiceId }: AddVoiceToCompanyParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/add-voice-to-company", "POST", { voiceId }, token);
};

// Remove a voice from the company's available voices
export const removeVoiceFromCompany = async ({
    token,
    voiceId,
}: RemoveVoiceFromCompanyParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/remove-voice-from-company", "POST", { voiceId }, token);
};
